import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  max-height: 100%;
  overflow: auto;
`;
